export type AgentType = "mcn" | "store";
export function normalizeAgentType(value: unknown): AgentType | null {
  return value === "mcn" ? value : null;
}
export const agentTypeLabel = (value: unknown) => value === "store" ? "线下采集点" : value === "mcn" ? "MCN 机构" : "区域代理";

/** New agency accounts use their type; city-only profiles remain readable. */
export function isAgentProfile(profile?: { agentType?: string | null; agentCity?: string | null } | null) {
  return Boolean(profile?.agentType || profile?.agentCity);
}
